import dynamic from 'next/dynamic';
import { DashboardContentTilesProps } from './DashboardContentTiles.types';

export const DashboardContentTiles = dynamic<{ model: DashboardContentTilesProps }>(() =>
  import('./DashboardContentTiles').then(mod => mod.DashboardContentTiles)
);
